import { ReactNode } from 'react';
import { Dialog } from '@headlessui/react';

const FeedbackDrawer = ({ open, onClose, title, children }: {
    open: boolean;
    onClose: () => void;
    title: string;
    children: ReactNode;
}) => (
    <Dialog open={open} onClose={onClose} className='relative z-50'>
        <div className='fixed inset-0 bg-black/45' aria-hidden='true' />
        <div className='fixed inset-0 flex justify-end'>
            <Dialog.Panel className='flex h-full w-full min-w-0 max-w-[1100px] flex-col bg-white shadow-2xl dark:bg-bgColor-darkMode sm:rounded-l-3xl'>
                <header className='mx-4 flex shrink-0 items-center justify-between gap-3 border-b border-gray-200 py-5 dark:border-gray-700 sm:mx-8 sm:py-6'>
                    <Dialog.Title as='h2' className='text-lg font-medium text-gray-900 dark:text-white'>{title}</Dialog.Title>
                    <button type='button' onClick={onClose} aria-label='Close feedback details'
                        className='inline-flex min-h-[44px] shrink-0 items-center gap-2 rounded-lg px-2 text-sm text-gray-800 hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green-700 dark:text-gray-200 dark:hover:bg-white/10'>
                        Go Back
                        <svg aria-hidden='true' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'><path d='M9 5V3h12v18H9v-2M3 12h12m-4-4 4 4-4 4' /></svg>
                    </button>
                </header>
                <div className='flex min-h-0 flex-1 flex-col'>{children}</div>
                <footer className='flex shrink-0 justify-end border-t border-gray-100 px-4 py-3 dark:border-gray-700 sm:px-8'>
                    <button type='button' onClick={onClose} className='min-h-[44px] rounded-full bg-gray-100 px-7 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-200'>Close</button>
                </footer>
            </Dialog.Panel>
        </div>
    </Dialog>
);

export default FeedbackDrawer;
